import { memo, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { useReduxAction } from "../utils/hooks";

import FirebaseAuth from "../components/firebase/FirebaseAuth";
import ViewTransitions from "../components/viewTransition/ViewTransitions";

function Root() {
   const location = useLocation();

   const loadApp = useReduxAction((actions) => actions.app.loadApp);

   useEffect(() => {
      loadApp();
   }, []);
   useEffect(() => {
      window.scrollTo(0, 0);
   }, [location.pathname]);

   return (
      <>
         <Outlet />

         <FirebaseAuth />

         <ViewTransitions />
      </>
   );
}

export default memo(Root);
